import { render } from "./DialogDeleteSegment.vue?vue&type=template&id=2d985d3c&scoped=true"
import script from "./DialogDeleteSegment.vue?vue&type=script&lang=js"
export * from "./DialogDeleteSegment.vue?vue&type=script&lang=js"

import "./DialogDeleteSegment.vue?vue&type=style&index=0&id=2d985d3c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d985d3c"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QCardActions,QBtn});qInstall(script, 'directives', {ClosePopup});
